import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import reduxForm from "redux-form/lib/reduxForm";
import formPropTypes from "redux-form/lib/propTypes";
import formValueSelector from "redux-form/lib/formValueSelector";
import actions from "redux-form/lib/actions";
import Field from "redux-form/lib/Field";
import { createSelector } from "reselect";
import Immutable from "immutable";
import { translate } from "react-i18next";
import isString from "lodash/isString";
import $ from "jquery";
import { push as routePush } from "react-router-redux";

import StepBox from "../StepBox";
import { price } from "../../../lib/utils";
import SchemaField from "../../../component/SchemaField";
import ProductImageGallery from "./ProductImageGallery";

import "./index.scss";

import { setProperty } from "../../../store/modules/cart";

import {
  ajvErrorMapperCreator,
  reduxFormOnSubmitFailScrollToFirstError,
  normalizePrice,
  formatPrice
} from "../../../lib/formUtils";
import createSchema from "../schema";
import CustomPriceField from "./CustomPriceField";
import ExtraProducts from "./ExtraProducts";

let schemaValidator = null;
const getSchemaValidator = schema => {
  if (!schemaValidator) {
    schemaValidator = createSchema(schema);
  }
  return schemaValidator;
};

export const getProductLabelTitle = props => {
  const { title, idx, hasCustomPrice, id } = props;

  if (hasCustomPrice && id === 0) {
    // customPrice selected
    return "Own price";
  }

  if (props.itemContext.get("items").size === 1) {
    return title;
  }

  if (hasCustomPrice) {
    if (idx <= 4) {
      switch (idx) {
        case 0:
          return "Standard";
        case 1:
          return "Medium";
        case 2:
          return "Large";
        case 3:
          return "Extra Large";
        case 4:
          return "XXL";
      }
    }
  }
  return title;
};

const getProductLabelTitleNode = props => {
  // eslint-disable-next-line react/prop-types
  if (props.useFullTitle) {
    // eslint-disable-next-line react/prop-types
    return props.title;
  }

  const title = getProductLabelTitle(props);
  // eslint-disable-next-line react/prop-types
  if (title === props.title || !isString(title)) {
    return title;
  }

  const smTitle = title
    .split(" ")
    .map(p => {
      if (p === "XXL") {
        return "XXL";
      }
      if (p === "Extra") {
        return "X";
      }
      return p.charAt(0);
    })
    .join("");
  return (
    <React.Fragment>
      <div className="Product__Title">{smTitle}</div>
      <div className="Product__Title--md">{title}</div>
    </React.Fragment>
  );
};

/**
 * Step1
 */
class Step1 extends Component {
  static propTypes = {
    ...formPropTypes,
    itemContext: PropTypes.instanceOf(Immutable.Map).isRequired,
    isOpen: PropTypes.bool.isRequired,
    isActive: PropTypes.bool.isRequired,
    hasStock: PropTypes.bool.isRequired,
    showButton: PropTypes.bool.isRequired,
    onNextStep: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    isMobileView: PropTypes.bool.isRequired,
    isProductSelected: PropTypes.bool.isRequired,
    isProductInCart: PropTypes.bool.isRequired,
    schema: PropTypes.instanceOf(Immutable.Map).isRequired,
    hasCustomPrice: PropTypes.bool,
    hasPackaging: PropTypes.bool,
    extraProducts: PropTypes.instanceOf(Immutable.List).isRequired,
    formChange: PropTypes.func.isRequired,
    formArrayPush: PropTypes.func.isRequired,
    clearSubmit: PropTypes.func.isRequired,
    clearSubmitErrors: PropTypes.func.isRequired,
    setProperty: PropTypes.func.isRequired,
    useFullTitle: PropTypes.bool.isRequired,
    routePush: PropTypes.func.isRequired
  };

  static defaultProps = {
    hasCustomPrice: false,
    hasPackaging: false,
    hasStock: true
  };

  state = {
    showExtraProducts: false
  };

  componentWillReceiveProps(props) {
    if (this.props.isProductInCart !== props.isProductInCart && !props.isProductInCart) {
      $(".Cart__Step1__ProductSelect__Select").slideDown();
    }
  }

  onSubmit = data => {
    this.props.formArrayPush("cart", "items", {
      uuid: this.props.itemContext.get("uuid"),
      extraProducts: [],
      ...data
    });
    this.props.clearSubmit();
    this.props.clearSubmitErrors();
    $(window).trigger("debloemist.cart.updated");

    this.setState({
      showExtraProducts: true
    });

    this.props.setProperty("currentItemInCart", true);

    $(".Cart__Step1__ProductSelect__Select").slideUp();

    if (window.matchMedia && window.matchMedia("(max-width: 1080px)").matches) {
      setTimeout(() => {
        // scroll to extra products
        const $container = $(".Cart__Step1");
        if ($container.length > 0 && $container.offset().top) {
          $("html, body").animate({ scrollTop: $container.offset().top - $("#header").height() - 20 }, 500, "linear");
        }
      }, 10);
    }
  };

  onClickGoToCart = () => {
    // we do not use the history here but reload the page (as this reloads the current webobject context)
    // this.props.routePush("/cart");
    document.location = "/cart";
  };

  renderProductOptionLabel = ({ schema, title, idx }) => {
    if (title === null) {
      return this.props.t("makeAChoice");
    }
    return `${title} ${schema.getIn(["enum_prices", idx])}`;
  };

  renderProductLabel = (fieldProps, props) => {
    const { schema, title, idx } = fieldProps;
    const { itemContext, t } = props;
    if (!itemContext) {
      return title;
    }
    const hasCustomPrice = itemContext.get("hasCustomPrice", false) && !itemContext.get("isMourning", false);
    const id = schema.getIn(["enum", idx]);

    const items = itemContext.get("items");
    const firstItem = items.first();
    const minPrice = price(firstItem.get("priceEx") * firstItem.get("taxMultiplier"));

    if (hasCustomPrice && id === 0) {
      return (
        <Field
          type="text"
          t={t}
          pattern="^[\d]+([,.][\d]+)?$"
          placeholder={`Min. ${minPrice}`}
          min={firstItem.get("priceEx") * firstItem.get("taxMultiplier")}
          name="customPrice"
          className="form-control"
          id="form-control-customPrice"
          component={CustomPriceField}
          normalize={normalizePrice}
          format={formatPrice}
        />
      );
    }

    return (
      <div className="ProductSelect__Label">
        <div className="ProductSelect__Label__Title">
          {getProductLabelTitleNode({
            useFullTitle: props.useFullTitle,
            schema,
            title,
            idx,
            itemContext,
            hasCustomPrice: itemContext.get("hasCustomPrice", false),
            id,
            isRadio: props.inputType === "radio"
          })}
        </div>
        <div className="ProductSelect__Label__Price">{schema.getIn(["enum_prices", idx])}</div>
      </div>
    );
  };

  renderProductSelect() {
    const { schema, useFullTitle, itemContext, t } = this.props;
    // eslint-disable-next-line prefer-destructuring
    const size = schema.getIn(["properties", "productCollectionMemberId", "enum"]).size;
    const hasCustomPrice = !itemContext.get("hasCustomPrice", false) || size === 1;
    return (
      <div
        className={`ProductSelect__Container${useFullTitle ? " ProductSelect__Container--md" : ""}${
          hasCustomPrice ? " ProductSelect__Container--md" : ""
        }`}
      >
        <SchemaField
          name="productCollectionMemberId"
          schema={schema}
          inputType={size <= 5 ? "radio" : null}
          label={false}
          itemContext={itemContext}
          useFullTitle={useFullTitle}
          t={t}
          labelRenderer={this.renderProductLabel}
          optionLabelRenderer={this.renderProductOptionLabel}
        />

        {this.props.hasPackaging && (
          <div>
            <label htmlFor="form-control-packagingId">{t("packaging")}</label>
            <SchemaField
              name="packagingId"
              schema={schema}
              label={false}
              optionLabelRenderer={this.renderProductOptionLabel}
            />
          </div>
        )}
      </div>
    );
  }

  render() {
    const { schema, isProductSelected, t, isMobileView, isCartEmpty } = this.props;

    const stepTitle = t(
      this.props.hasCustomPrice ? "Fill in an own price or select your product" : "Select your product"
    );

    if (!this.props.hasStock || this.props.isKmtUser) {
      return (
        <div className="Cart__Step1">
          <StepBox number={1} title={stepTitle} isOpen isActive showButton={false}>
            <div className="Cart__Step1__ProductView">
              {!isMobileView && <ProductImageGallery className="pt-4" />}
              <div className="Cart__Step1__ProductSelect pt-4">
                <div className="alert alert-danger">
                  {this.props.isKmtUser ? (
                    <React.Fragment>
                      <h3>KMT gebruiker gedetecteerd</h3>
                      Een bestelling plaatsen is niet mogelijk <a href="/logout#logout">Uitloggen</a>
                    </React.Fragment>
                  ) : (
                    t("This product is currently not in stock, you can find comparable products via the menu.")
                  )}
                </div>
              </div>
            </div>
          </StepBox>
        </div>
      );
    }
    return (
      <div className="Cart__Step1">
        <StepBox
          number={1}
          title={stepTitle}
          isOpen={this.props.isOpen}
          isActive={this.props.isActive}
          isValid={this.props.isValid}
          onNextStep={this.props.onNextStep}
          showButton={this.props.showButton}
        >
          <div className="Cart__Step1__ProductView">
            {!isMobileView && <ProductImageGallery className="pt-4" />}
            <div className="Cart__Step1__ProductSelect pt-4">
              <div className="Cart__Step1__ProductSelect__Select">
                <Field name="webProductId" component="input" type="hidden" />

                <div className="col-12 Cart__Step1__ProductSelect__Title">{this.props.itemContext.get("title")}</div>

                <div className="col-12 Cart__Step1__ProductSelect__ProductSelect">{this.renderProductSelect()}</div>

                <div className="col-12 Cart__Step1__ProductSelect__CustomSelect">
                  <div className="row Cart__Step1__ProductSelect__CustomSelect__Quantity">
                    <SchemaField name="quantity" label={t("quantity")} schema={schema} disabled={!isProductSelected} />
                  </div>

                  <div className="d-flex flex-column mb-4">
                    <button
                      className="btn btn-secondary"
                      disabled={!isProductSelected}
                      onClick={this.props.handleSubmit(this.onSubmit)}
                    >
                      {t("Add to cart")}
                    </button>
                    {!isCartEmpty && (
                      <div>
                        <div className="d-flex justify-content-center align-content-center p-2">{t("or")}</div>
                        <button type="button" className="btn btn-inverted" onClick={this.onClickGoToCart}>
                          {t("Complete order")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {this.props.submitSucceeded && this.props.cartItemIndex !== -1 && (
                <div className="alert alert-success">
                  <i className="fa fa-check" /> {t("Product has been added")}
                </div>
              )}

              {this.state.showExtraProducts && (
                <ExtraProducts
                  cartItem={this.props.cartItem}
                  cartItemIndex={this.props.cartItemIndex}
                  isProductInCart={this.state.showExtraProducts}
                  extraProducts={this.props.extraProducts}
                />
              )}
            </div>
          </div>
        </StepBox>
      </div>
    );
  }
}

const EMPTY_MAP = Immutable.Map();
const EMPTY_LIST = Immutable.List();

const selectContext = createSelector(
  [state => state.get("context")],
  context => context
);

const selectItemContext = createSelector(
  [state => selectContext(state)],
  context => {
    if (!context) {
      return EMPTY_MAP;
    }
    return context.get("currentItemContext", EMPTY_MAP).set("uuid", context.getIn(["webProduct", "uuid"]));
  }
);

const selectExtraProducts = createSelector(
  [itemContext => itemContext, (itemContext, productCollectionMemberId) => productCollectionMemberId],
  (itemContext, productCollectionMemberId) => {
    const extraProducts = itemContext.get("extraProducts");
    if (!extraProducts) {
      return EMPTY_LIST;
    }
    if (!itemContext.get("canHaveVase")) {
      return extraProducts;
    }
    return extraProducts.map(p => {
      if (p.get("id") === -123) {
        // vase
        return p.set(
          "priceEx",
          itemContext.get("items").reduce((c, item) => {
            if (item.get("id") === productCollectionMemberId) {
              c = item.get("vasePriceEx");
            }
            return c;
          }, p.get("priceEx"))
        );
      }
      return p;
    });
  }
);

const schemaSelector = createSelector(
  [
    state => state.cart.getIn(["schema", "properties", "items", "items"], EMPTY_MAP),
    state => state.cart.getIn(["context", "currentItemContext"])
  ],
  (schema, itemContext) => {
    const packaging = itemContext.get("packaging", EMPTY_LIST);

    // const hasCustomPrice = itemContext.get('hasCustomPrice', false) && !itemContext.get('isMourning', false);
    const items = itemContext.get("items", EMPTY_LIST);

    /* .push(hasCustomPrice ? Immutable.Map({
    id: 0,
    title: 'Own price'
  }) : null).filter(v => !!v); */

    // console.log(
    //   schema
    //     .set("$id", "Product")
    //     .setIn(["properties", "packagingId", "enum"], packaging.map(i => i.get("id")).insert(0, 0))
    //     .setIn(["properties", "packagingId", "enum_titles"], packaging.map(i => i.get("title")).insert(0, null))
    //     .set(
    //       "required",
    //       schema
    //         .get("required")
    //         .push(packaging.size ? "packagingId" : null)
    //         .filter(v => !!v)
    //     )
    //     .setIn(
    //       ["properties", "packagingId", "enum_prices"],
    //       packaging.map(i => price(i.get("priceEx") * i.get("taxMultiplier"))).insert(0, 0)
    //     )
    //     .setIn(["properties", "productCollectionMemberId", "enum"], items.map(i => i.get("id")))
    //     .setIn(["properties", "productCollectionMemberId", "enum_titles"], items.map(i => i.get("title")))
    //     .setIn(
    //       ["properties", "productCollectionMemberId", "enum_prices"],
    //       items.map(i => price(i.get("priceEx") * i.get("taxMultiplier")))
    //     )
    //     .toJS()
    // );
    return schema
      .set("$id", "Product")
      .setIn(["properties", "packagingId", "enum"], packaging.map(i => i.get("id")).insert(0, 0))
      .setIn(["properties", "packagingId", "enum_titles"], packaging.map(i => i.get("title")).insert(0, null))
      .set(
        "required",
        schema
          .get("required")
          .push(packaging.size ? "packagingId" : null)
          .filter(v => !!v)
      )
      .setIn(
        ["properties", "packagingId", "enum_prices"],
        packaging.map(i => price(i.get("priceEx") * i.get("taxMultiplier"))).insert(0, 0)
      )
      .setIn(["properties", "productCollectionMemberId", "enum"], items.map(i => i.get("id")))
      .setIn(["properties", "productCollectionMemberId", "enum_titles"], items.map(i => i.get("title")))
      .setIn(
        ["properties", "productCollectionMemberId", "enum_prices"],
        items.map(i => price(i.get("priceEx") * i.get("taxMultiplier")))
      );
  }
);

const cartValueSelector = formValueSelector("cart");

const valueSelector = formValueSelector("product");

const getItemIndexInCartSelector = createSelector(
  [
    state => cartValueSelector(state, "items"),
    state => valueSelector(state, "uuid"),
    state => valueSelector(state, "productCollectionMemberId"),
    state => valueSelector(state, "customPrice")
  ],
  (items, uuid) =>
    items.reduce((carry, item, idx) => {
      if (item.uuid === uuid) {
        carry = idx;
      }
      return carry;
    }, -1)
);

const getItemInCartSelector = createSelector(
  [state => cartValueSelector(state, "items"), state => getItemIndexInCartSelector(state)],
  (items, index) => items[index]
);

const selectProductCollectionMemberId = createSelector(
  [state => selectItemContext(state.cart), () => window.document.location.hash],
  (item, hash) => {
    const items = item.get("items");
    if (!items || items.size === 0) {
      return 0;
    }
    if (hash && /^#selectItem=/.test(hash)) {
      const id = parseInt(hash.replace(/^#selectItem=([\d]+).*/, "$1"), 10);
      // console.log('id', id, items.size, items.filter(i => i.get('id') === id).size);
      // console.log(items.toJS());
      if (id && items.filter(i => i.get("id") === id).size === 1) {
        return id;
      }
    }
    if (items.size === 1 || items.size >= 5) {
      return items.getIn([0, "id"]);
    }
    return items.getIn([1, "id"]);
  }
);

export default translate()(
  connect(
    (state, props) => {
      const productCollectionMemberId = valueSelector(state, "productCollectionMemberId");

      const defaultTaxMultiplier = state.cart.getIn(["context", "defaultTaxMultiplier"], 1.09);

      const itemContext = selectItemContext(state.cart);
      const cartItemIndex = getItemIndexInCartSelector(state);
      return {
        isCartEmpty: cartValueSelector(state, "items").length === 0,
        initialValues: {
          uuid: itemContext.get("uuid", 0),
          webProductId: itemContext.get("webProductId", 0),
          productCollectionMemberId: selectProductCollectionMemberId(state),
          quantity: 1
        },
        useFullTitle: true,
        isMobileView: state.app.get("isMobileView"),
        // formValues: state.form.cart && state.form.cart.values && state.form.cart.items,
        itemContext,
        cartItemIndex,
        cartItem: getItemInCartSelector(state),
        defaultTaxMultiplier,
        schema: schemaSelector(state, props),
        hasCustomPrice: false,
        hasPackaging: state.cart.getIn(["context", "currentItemContext", "packaging", 0], null) !== null,
        isProductSelected: !!(productCollectionMemberId || valueSelector(state, "customPrice")),
        isProductInCart: cartItemIndex !== -1,
        extraProducts: selectExtraProducts(
          selectItemContext(state.cart),
          productCollectionMemberId,
          defaultTaxMultiplier,
          props.t
        )
      };
    },
    {
      setProperty,
      routePush,
      formChange: actions.change,
      formArrayPush: actions.arrayPush,
      clearSubmit: actions.clearSubmit,
      clearSubmitErrors: actions.clearSubmitErrors
    }
  )(
    reduxForm({
      form: "product",
      validate: (data, props) => {
        if (!getSchemaValidator(props.schema)) {
          return {};
        }
        if (__DEV__) {
          // eslint-disable-next-line no-console
          console.log("product.data", data);
        }
        // console.log('asyncValidate', props);
        const isValid = getSchemaValidator(props.schema).validate("Product", data);
        if (__DEV__) {
          // eslint-disable-next-line no-console
          console.log("product.isValid", isValid);
        }

        const errors = {};

        if (!isValid) {
          // eslint-disable-next-line no-console,no-unused-expressions
          if ((window.logSchemaErrors || __DEV__) && window.console.log) {
            window.console.log("product.ajv.errors", schemaValidator.errors);
          }
          schemaValidator.errors.map(ajvErrorMapperCreator(errors, props.schema, props.t));
        }

        if (__DEV__) {
          // eslint-disable-next-line no-console
          console.log("product.errors", errors);
        }
        return errors;
      },
      onSubmitFail: reduxFormOnSubmitFailScrollToFirstError
    })(Step1)
  )
);
